export interface CalendarSummary {
  id: string;
  summary: string;
  primary: boolean;
  accessRole: string;
}

export interface CalendarListPayload {
  type: "calendar_list";
  calendars: CalendarSummary[];
}

const isString = (v: unknown): v is string => typeof v === "string";

const isCalendarSummary = (v: unknown): v is CalendarSummary => {
  if (!v || typeof v !== "object") return false;
  const r = v as Record<string, unknown>;
  return isString(r.id) && isString(r.summary) && typeof r.primary === "boolean" && isString(r.accessRole);
};

export const parseCalendarListPayload = (v: unknown): CalendarListPayload | null => {
  if (!v || typeof v !== "object") return null;
  const r = v as Record<string, unknown>;
  if (r.type !== "calendar_list") return null;
  if (!Array.isArray(r.calendars)) return null;
  if (!r.calendars.every(isCalendarSummary)) return null;
  return { type: "calendar_list", calendars: r.calendars };
};
